// @ts-nocheck
import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Video, MoreVertical } from "lucide-react"; // Added Video icon
import {
  addAchievementToProfile,
  fetchUserOwnerProfile,
  fetchUserPosts,
  fetchUserPublicProfile,
  removeAchievementFromProfile,
} from "../store/postsSlice";
import { logoutUser } from "../store/userSlice";
import { BASE_URL } from "../Constants/BaseUrl";
import { formatDateMMDDYY } from "../Utils/DateFormater";
import EditProfileModal from "../components/EditProfleModal";
import ImagePicker from "../components/ImagePicker";
import { useAppSelector } from "../hooks/useRedux";
import SkeletonLoader from "../components/SkeletonLoader";
import BlockUserModal from "../components/BlockUserModal";
import useHandleChat from "../hooks/useHandleChat";
import { db } from "../firebase/firebase"; // Import Firestore instance
import { doc, onSnapshot } from "firebase/firestore"; // Web Firestore imports

const PublicProfile = () => {
  const color = "text-white bg-gray-900";
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const targetUserId = location.state?.user_id;

  const userDetails = useAppSelector((state) => state.posts.userPublicProfile);
  const user = useAppSelector((state) => state.user);
  const { loading } = useAppSelector((state) => state.posts);

  const [refreshing, setRefreshing] = useState(false);
  const [showImagePicker, setShowImagePicker] = useState(false);
  const [profilePicLoading, setProfilePicLoading] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [text, setText] = useState("");
  const [add, setAdd] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showBlockModal, setShowBlockModal] = useState(false);
  const [isChatLoading, setIsChatLoading] = useState(false);
  const [isLive, setIsLive] = useState(false);
  const [liveChannelName, setLiveChannelName] = useState(null);

  const handleChat = useHandleChat(user, userDetails, setIsChatLoading);

  // Firestore listener for live status
  useEffect(() => {
    if (userDetails?.user_id) {
      const unsubscribe = onSnapshot(
        doc(db, "live_streams", userDetails.user_id.toString()),
        (doc) => {
          if (doc.exists() && doc.data()?.isLive) {
            console.log("Firestore live data:", doc.data());
            setIsLive(true);
            setLiveChannelName(doc.data()?.channelName || null);
          } else {
            setIsLive(false);
            setLiveChannelName(null);
          }
        },
        (error) => {
          console.error("Error listening to live status:", error);
          setIsLive(false);
          setLiveChannelName(null);
          toast.error("Failed to check live status");
        },
      );

      return () => unsubscribe();
    }
  }, [userDetails?.user_id]);

  useEffect(() => {
    if (targetUserId) {
      dispatch(fetchUserPublicProfile(targetUserId));
    }
  }, [dispatch, targetUserId]);

  useEffect(() => {
    if (!userDetails) return;

    if (userDetails?.profile_visibility === "private") {
      toast.error("This account is private and you cannot access it.", {
        position: "top-center",
        autoClose: 5000,
        style: { fontWeight: 600, fontSize: 16 },
      });

      if (user?.role === "coach") {
        navigate("/profile-coach");
      } else {
        navigate("/profile");
      }
    }
  }, [userDetails, user?.role, navigate]);

  useEffect(() => {
    if (location.state?.user_id) {
      dispatch(fetchUserPublicProfile(location.state.user_id));
    }
  }, [dispatch, location.state.user_id]);

  // Handle Block User action
  const handleBlockUser = () => {
    setShowBlockModal(true);
    setShowDropdown(false);
  };

  const handleModalClose = () => {
    setShowBlockModal(false);
  };

  if (loading) {
    return (
      <div className="min-h-screen p-4 bg-black text-white">
        <SkeletonLoader />
      </div>
    );
  }

  return (
    <div className="min-h-screen p-4 bg-black text-white">
      <div className="flex justify-between items-center mb-6 relative">
        <div className="flex items-center gap-4">
          <img
            // src={
            //   userDetails?.profile_picture
            //     ? `${BASE_URL}/${userDetails?.profile_picture}`
            //     : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQfj3Bm37Nn_rBQHkIzxnpmGMv3AnLWNYvA1_GwXzebfQ7rxLHl0fRsKo6mIi1SmoOiCL4&usqp=CAU"
            // }
            src={
              userDetails?.profile_picture?.startsWith("https")
                ? userDetails.profile_picture
                : userDetails?.profile_picture
                  ? `${BASE_URL}/${userDetails.profile_picture}`
                  : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQfj3Bm37Nn_rBQHkIzxnpmGMv3AnLWNYvA1_GwXzebfQ7rxLHl0fRsKo6mIi1SmoOiCL4&usqp=CAU"
            }
            alt="Profile"
            className="w-32 h-32 rounded-full border-2 border-white ml-4"
            onClick={() => setShowImagePicker(true)}
          />
          <div>
            <div className="flex items-center gap-2">
              <h2 className="text-lg font-semibold">
                {userDetails?.athlete_info?.first_name}{" "}
                {userDetails?.athlete_info?.last_name}
              </h2>
              {/* LIVE Indicator */}
              {/* {isLive && (
                <button
                  onClick={() => {
                    if (liveChannelName) {
                      navigate("/live-stream", {
                        state: {
                          isBroadcaster: false,
                          channelName: liveChannelName,
                        },
                      });
                    } else {
                      toast.error("Invalid live stream channel");
                    }
                  }}
                  className="flex items-center gap-1 bg-red-600 text-white text-sm font-semibold px-2 py-1 rounded-2xl"
                >
                  <Video className="w-4 h-4" />
                  <span>LIVE</span>
                </button>
              )} */}
            </div>
            {/* <div className="flex gap-4 mt-2">
              <span>0 Followers</span>
              <span>0 Following</span>
            </div> */}
            <button
              onClick={handleChat}
              disabled={isChatLoading}
              className={`px-4 py-1 rounded bg-[#666666] text-white text-sm hover:bg-gray-700 mt-5 ${
                isChatLoading ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              {isChatLoading ? "Loading..." : "Message"}
            </button>
          </div>
        </div>
        {/* MoreVertical Icon */}
        <button
          onClick={() => setShowDropdown(!showDropdown)}
          className="text-white hover:text-gray-300"
        >
          <MoreVertical className="w-8 h-8" />
        </button>
        {/* Dropdown Menu */}
        {showDropdown && (
          <div className="absolute top-3 right-3 bg-gray-900 border border-gray-700 rounded-md shadow-lg z-10">
            <button
              onClick={handleBlockUser}
              className="block w-full text-left px-4 py-2 text-sm text-white hover:bg-gray-800"
            >
              Block User
            </button>
          </div>
        )}
      </div>

      <BlockUserModal
        visible={showBlockModal}
        onClose={handleModalClose}
        userId={location.state?.user_id}
      />

      {/* Achievements */}
      <div className="p-4 rounded mb-6">
        <div className="flex justify-between items-center mb-2">
          <h3 className="text-white font-semibold text-sm">STATISTICS</h3>
        </div>
        {add && (
          <div className="mb-3">
            <input
              type="text"
              maxLength={100}
              value={text}
              onChange={(e) => setText(e.target.value)}
              onBlur={() => setAdd(false)}
              onKeyDown={(e) => e.key === "Enter" && addAchievementHandler()}
              className="w-full p-2 rounded bg-gray-900 text-white border border-gray-600"
              placeholder="🏆 Write your achievement"
            />
            <p className="text-xs text-gray-400 text-right mt-1">
              {100 - text.length} characters left
            </p>
          </div>
        )}
        {userDetails?.athlete_achievements?.map((item, index) => (
          <div
            key={index}
            className="flex justify-between items-center border-b border-gray-700 py-2"
          >
            <p className="text-white text-sm flex-1 mr-2">{item.achievement}</p>
          </div>
        ))}
      </div>

      {/* Profile info block */}
      <div className="grid grid-cols-2 gap-4 text-sm text-white ml-5">
        <div>
          {/* <p>
            <strong>Date of Birth:</strong>{" "}
            {formatDateMMDDYY(userDetails?.athlete_info?.dob) || "Not Found"}
          </p> */}
          {/* <p>
            <strong>Gender:</strong>{" "}
            {userDetails?.athlete_info?.gender || "Not Found"}
          </p> */}
          <p>
            <strong>Weight:</strong>{" "}
            {userDetails?.athlete_info?.weight || "Not Found"}
          </p>
          <p>
            <strong>Height:</strong>{" "}
            {userDetails?.athlete_info?.height || "Not Found"}
          </p>
          <p>
            <strong>School:</strong>{" "}
            {userDetails?.athlete_info?.current_school || "Not Found"}
          </p>
          <p>
            <strong>Sport:</strong>{" "}
            {userDetails?.athlete_info?.sport_name || "Not Found"}
          </p>
        </div>
        <div>
          <p>
            <strong>Position:</strong>{" "}
            {userDetails?.athlete_info?.position || "Not Found"}
          </p>
          <p>
            <strong>School Year:</strong>{" "}
            {userDetails?.athlete_info?.school_year || "Not Found"}
          </p>
          <p>
            <strong>Division:</strong>{" "}
            {userDetails?.athlete_info?.division || "Not Found"}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-2 mt-10">
        {userDetails?.posts?.length > 0 ? (
          userDetails.posts.map((item) => {
            const imageUrl = item.image_url;
            const videoUrl = item.video_url;
            const likesCount = item.like_count || 0;

            const isVideo = Boolean(videoUrl);
            const isImage = Boolean(imageUrl);

            return (
              <div
                key={item.post_id}
                className="relative aspect-square overflow-hidden rounded-md cursor-pointer"
                onClick={() =>
                  navigate("/post-preview", {
                    state: {
                      currentPost: item,
                      posts: userDetails?.posts,
                    },
                  })
                }
              >
                {isImage ? (
                  <img
                    // src={`${BASE_URL}${imageUrl}`}
                    src={
                      imageUrl?.startsWith("https")
                        ? imageUrl
                        : imageUrl
                          ? `${BASE_URL}/${imageUrl}`
                          : undefined
                    }
                    alt="post"
                    className="w-full h-full object-cover"
                  />
                ) : isVideo ? (
                  <video
                    // src={`${BASE_URL}${videoUrl}`}
                    src={
                      videoUrl?.startsWith("https")
                        ? videoUrl
                        : videoUrl
                          ? `${BASE_URL}/${videoUrl}`
                          : undefined
                    }
                    className="w-full h-full object-cover"
                    muted
                    loop
                    playsInline
                  />
                ) : null}

                {/* Bottom-left: Likes + Heart */}
                <div className="absolute bottom-1 left-1 flex items-center gap-1 text-white text-xs">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-4 h-4 text-red-500"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M16.5 3.75a5.25 5.25 0 00-4.5 2.4 5.25 5.25 0 00-9 3.6c0 5.25 9 11.25 9 11.25s9-6 9-11.25a5.25 5.25 0 00-4.5-5.4z"
                    />
                  </svg>
                  {likesCount}
                </div>

                {/* Bottom-right: Media icon */}
                <div className="absolute bottom-1 right-1 text-white text-xs">
                  {isImage && <span>📷</span>}
                  {isVideo && <span>🎥</span>}
                </div>
              </div>
            );
          })
        ) : (
          <div className="col-span-3 text-center text-gray-500 mt-4">
            No posts yet
          </div>
        )}
      </div>
    </div>
  );
};

export default PublicProfile;
